// Dados de exemplo no formato de GET /rpg/reis (docs/api-publica-rpg.md da API).
// O Provider usa estes dados quando a API nao responde.
module.exports = {
  reisList: [
    {
      chave: "rei-das-raids",
      nome: "Rei das Raids",
      cor: "#ff4d4d",
      unidade: "vezes",
      atividades: [{ key: "raid", nome: "Raid", emoji: "🧨" }],
      dono: {
        discordId: "300000000000000004",
        slug: "sanji_blackleg",
        nome: "sanji_blackleg",
        avatar: "https://cdn.discordapp.com/embed/avatars/4.png",
        valor: 42,
        desde: "2026-07-02T00:30:00.000Z",
      },
      top: [
        {
          posicao: 1,
          discordId: "300000000000000004",
          slug: "sanji_blackleg",
          nome: "sanji_blackleg",
          avatar: "https://cdn.discordapp.com/embed/avatars/4.png",
          valor: 42,
        },
        { posicao: 2, discordId: "300000000000000002", slug: "luffy_mugen", nome: "luffy_mugen", avatar: "https://cdn.discordapp.com/embed/avatars/2.png", valor: 20 },
        { posicao: 3, discordId: "300000000000000005", slug: "robin_ohara", nome: "robin_ohara", avatar: "https://cdn.discordapp.com/embed/avatars/5.png", valor: 18 },
        { posicao: 4, discordId: "300000000000000001", slug: "zoro_void", nome: "zoro_void", avatar: "https://cdn.discordapp.com/embed/avatars/1.png", valor: 14 },
        { posicao: 5, discordId: "300000000000000012", slug: "yamato_oni", nome: "yamato_oni", avatar: "https://cdn.discordapp.com/embed/avatars/0.png", valor: 12 },
      ],
    },
    {
      chave: "rei-do-pvp",
      nome: "Rei do PvP",
      cor: "#9b4dff",
      unidade: "vezes",
      atividades: [{ key: "pvp_win", nome: "PvP vitória", emoji: "🥇" }],
      dono: {
        discordId: "300000000000000001",
        slug: "zoro_void",
        nome: "zoro_void",
        avatar: "https://cdn.discordapp.com/embed/avatars/1.png",
        valor: 28,
        desde: "2026-08-15T22:10:00.000Z",
      },
      top: [
        { posicao: 1, discordId: "300000000000000001", slug: "zoro_void", nome: "zoro_void", avatar: "https://cdn.discordapp.com/embed/avatars/1.png", valor: 28 },
        { posicao: 2, discordId: "300000000000000002", slug: "luffy_mugen", nome: "luffy_mugen", avatar: "https://cdn.discordapp.com/embed/avatars/2.png", valor: 12 },
        { posicao: 3, discordId: "300000000000000012", slug: "yamato_oni", nome: "yamato_oni", avatar: "https://cdn.discordapp.com/embed/avatars/0.png", valor: 10 },
        { posicao: 4, discordId: "300000000000000006", slug: "usopp_sniper", nome: "usopp_sniper", avatar: "https://cdn.discordapp.com/embed/avatars/0.png", valor: 7 },
        {
          posicao: 5,
          discordId: "300000000000000004",
          slug: "sanji_blackleg",
          nome: "sanji_blackleg",
          avatar: "https://cdn.discordapp.com/embed/avatars/4.png",
          valor: 5,
        },
      ],
    },
    {
      chave: "imperador-dos-mares",
      nome: "Imperador dos Mares",
      cor: "#3b82f6",
      unidade: "vezes",
      atividades: [
        { key: "leviathan", nome: "Leviathan", emoji: "🐲" },
        { key: "volcano", nome: "Ilha do Vulcão", emoji: "🌋" },
        { key: "terroshark", nome: "Terroshark", emoji: "🦈" },
        { key: "sea_beast", nome: "Sea Beast", emoji: "🌊" },
        { key: "ghost_ship", nome: "Navio Fantasma", emoji: "👻" },
      ],
      dono: {
        discordId: "300000000000000002",
        slug: "luffy_mugen",
        nome: "luffy_mugen",
        avatar: "https://cdn.discordapp.com/embed/avatars/2.png",
        valor: 47,
        desde: "2026-06-11T19:45:00.000Z",
      },
      top: [
        { posicao: 1, discordId: "300000000000000002", slug: "luffy_mugen", nome: "luffy_mugen", avatar: "https://cdn.discordapp.com/embed/avatars/2.png", valor: 47 },
        { posicao: 2, discordId: "300000000000000010", slug: "jinbe_mar", nome: "jinbe_mar", avatar: "https://cdn.discordapp.com/embed/avatars/4.png", valor: 17 },
        { posicao: 3, discordId: "300000000000000001", slug: "zoro_void", nome: "zoro_void", avatar: "https://cdn.discordapp.com/embed/avatars/1.png", valor: 7 },
        { posicao: 4, discordId: "300000000000000005", slug: "robin_ohara", nome: "robin_ohara", avatar: "https://cdn.discordapp.com/embed/avatars/5.png", valor: 5 },
        { posicao: 5, discordId: "300000000000000007", slug: "chopper_doc", nome: "chopper_doc", avatar: "https://cdn.discordapp.com/embed/avatars/1.png", valor: 4 },
      ],
    },
    {
      chave: "magnata-dos-mares",
      nome: "Magnata dos Mares",
      cor: "#facc15",
      unidade: "",
      atividades: [{ key: "gold", nome: "Gold", emoji: "🪙" }],
      dono: {
        discordId: "300000000000000003",
        slug: "300000000000000003",
        nome: "Nami ✦",
        avatar: "https://cdn.discordapp.com/embed/avatars/3.png",
        valor: 1850000,
        desde: "2026-09-03T14:00:00.000Z",
      },
      top: [
        {
          posicao: 1,
          discordId: "300000000000000003",
          slug: "300000000000000003",
          nome: "Nami ✦",
          avatar: "https://cdn.discordapp.com/embed/avatars/3.png",
          valor: 1850000,
        },
        { posicao: 2, discordId: "300000000000000002", slug: "luffy_mugen", nome: "luffy_mugen", avatar: "https://cdn.discordapp.com/embed/avatars/2.png", valor: 480000 },
        {
          posicao: 3,
          discordId: "300000000000000008",
          slug: "300000000000000008",
          nome: "Franky SUPER",
          avatar: "https://cdn.discordapp.com/embed/avatars/1.png",
          valor: 360000,
        },
      ],
    },
    {
      chave: "lorde-dos-fragmentos",
      nome: "Lorde dos Fragmentos",
      cor: "#22d3ee",
      unidade: "",
      atividades: [{ key: "fragments", nome: "Fragmentos", emoji: "💎" }],
      dono: {
        discordId: "300000000000000005",
        slug: "robin_ohara",
        nome: "robin_ohara",
        avatar: "https://cdn.discordapp.com/embed/avatars/5.png",
        valor: 96000,
        desde: "2026-08-28T20:20:00.000Z",
      },
      top: [
        { posicao: 1, discordId: "300000000000000005", slug: "robin_ohara", nome: "robin_ohara", avatar: "https://cdn.discordapp.com/embed/avatars/5.png", valor: 96000 },
        {
          posicao: 2,
          discordId: "300000000000000003",
          slug: "300000000000000003",
          nome: "Nami ✦",
          avatar: "https://cdn.discordapp.com/embed/avatars/3.png",
          valor: 32000,
        },
        {
          posicao: 3,
          discordId: "300000000000000008",
          slug: "300000000000000008",
          nome: "Franky SUPER",
          avatar: "https://cdn.discordapp.com/embed/avatars/1.png",
          valor: 12500,
        },
      ],
    },
    {
      chave: "lenda-viva",
      nome: "Lenda Viva",
      cor: "#e5e7eb",
      unidade: "pts",
      atividades: [{ key: "achievement", nome: "Conquista", emoji: "🏆" }, { key: "quiz", nome: "Quiz", emoji: "🧠" }],
      dono: null,
      top: [
        { posicao: 1, discordId: "300000000000000012", slug: "yamato_oni", nome: "yamato_oni", avatar: "https://cdn.discordapp.com/embed/avatars/0.png", valor: 268 },
        { posicao: 2, discordId: "300000000000000005", slug: "robin_ohara", nome: "robin_ohara", avatar: "https://cdn.discordapp.com/embed/avatars/5.png", valor: 211 },
        { posicao: 3, discordId: "300000000000000003", slug: "300000000000000003", nome: "Nami ✦", avatar: "https://cdn.discordapp.com/embed/avatars/3.png", valor: 150 },
        { posicao: 4, discordId: "300000000000000002", slug: "luffy_mugen", nome: "luffy_mugen", avatar: "https://cdn.discordapp.com/embed/avatars/2.png", valor: 122 },
        { posicao: 5, discordId: "300000000000000007", slug: "chopper_doc", nome: "chopper_doc", avatar: "https://cdn.discordapp.com/embed/avatars/1.png", valor: 100 },
      ],
    },
  ],
};
